/**
 * Centralized color tokens for workflow components.
 * All values reference CSS variables from globals.css.
 */

export const workflowColors = {
  // Handle/Anchor colors - original hex colors that work well with pastel nodes
  handle: {
    default: 'var(--muted-foreground)',
    chatModel: '#a855f7', // purple
    memory: '#3b82f6',    // blue
    tools: '#10b981',     // green
    parser: '#f97316',    // orange
  },

  // Edge colors - original hex colors
  edge: {
    default: { normal: 'var(--muted-foreground)', active: 'var(--primary)' },
    chatModel: { normal: '#a855f7', active: '#7c3aed' },
    memory: { normal: '#3b82f6', active: '#2563eb' },
    tools: { normal: '#10b981', active: '#059669' },
    parser: { normal: '#f97316', active: '#ea580c' },
  },

  // Execution status
  status: {
    idle: 'var(--muted-foreground)',
    running: 'var(--accent-info-500)',
    success: 'var(--accent-success-500)',
    error: 'var(--destructive)',
  },

  // Node states
  node: {
    disabled: {
      background: 'var(--muted)',
      border: 'var(--border)',
      icon: 'var(--muted-foreground)',
    },
    tool: {
      background: 'var(--accent-success-50)',
      border: 'var(--accent-success-500)',
    },
  },
} as const;

// Tailwind class mappings for use in className
export const workflowClasses = {
  handle: {
    default: 'bg-muted-foreground',
    chatModel: 'bg-[#a855f7]',
    memory: 'bg-[#3b82f6]',
    tools: 'bg-[#10b981]',
    parser: 'bg-[#f97316]',
  },

  status: {
    idle: '',
    running: 'ring-2 ring-accent-info-500 animate-pulse',
    success: 'ring-2 ring-accent-success-500',
    error: 'ring-2 ring-destructive',
  },

  label: {
    chatModel: 'text-[#a855f7]',
    memory: 'text-[#3b82f6]',
    tools: 'text-[#10b981]',
    parser: 'text-[#f97316]',
  },
} as const;

// Type for handle types
export type HandleType = keyof typeof workflowColors.handle;
export type StatusType = keyof typeof workflowColors.status;
